<template>
  <div class="navbar-button-container">
    <navbar-button @click="showCalendar">
      <i style="width: 28px, height: 28px" class="el-icon-timer"></i>
    </navbar-button>
  </div>
</template>

<script>
import NavbarButton from "@/components/navbar/NavbarButton.vue";

export default {
  name: "NavbarCalendar",
  components: { NavbarButton },
  data() {
    return {};
  },
  methods: {
    showCalendar() {
      this.$emit("isShowCalendar");
    }
  }
};
</script>

<style scoped lang="scss">
.navbar-button-container {
  height: 50px;
  margin-top: auto;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: auto;
}
.el-icon-timer {
  font-size: 23px;
}
</style>
